<template src="./SpecialtiesManagement.html" />

<script>
import { computed } from "vue"
import { useStore } from "@/store/store.js"
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue"

export default {
  name: 'SpecialtiesManagement',

  components: { WholeMultiselect },

  data () {
    return {
      specialties: [],
      plans: [],

      selected: null,
      isEditModal: false,
      packIndex: 0,
      packTimeOut: null,
      packRemovalName: "",

      currentPage: 1,
      totalPages: 0
    }
  },

  setup() {
    const store = useStore()

    return {
      isMobile: computed(() => store.getters.isMobile),      
      getSpecialtiesList: (par = {}) => store.dispatch("getSpecialties", par),
      getSpecialtyById: (id) => store.dispatch("getSpecialtyById", id),
      getAllPlans: () => store.dispatch("getAllPlans"),
      setSpecialty: (payload) => store.dispatch("setSpecialty", payload),
      updateSpecialty: (payload) => store.dispatch("updateSpecialty", payload),
    }
  },

  computed: {
    computedSpecialties() {
      return this.specialties.map((obj) => ({ value: obj.id, text: obj.name }))
    },
    isPaginated () {
      return this.totalPages > 1
    },
    isModalTabsShow() {
      return this.selected && this.selected.packs.length
    },
    isModalButtonDisabled() {
      if (this.selected && this.selected.packs) {
        const { packs } = this.selected

        const packsNames = packs.map((pack) => !!pack.name)
        const packsValues = packs.map((pack) => !!pack.value)
        const packsPlans = packs.map((pack) => pack.plans.length > 0)
        const packsInvalids = packs.map((pack) => (pack.invalidName || pack.invalidValue))
  
        const chkPacks = packs.length
        const chkPacksValues = packsValues.filter((val) => val).length === chkPacks
        const chkPacksPlans = packsPlans.filter((val) => val).length === chkPacks
        const chkPacksNames = packsNames.filter((val) => val).length === chkPacks
        const chkPacksInvalids = packsInvalids.filter((val) => val).length === 0
  
        return !(chkPacks && chkPacksValues && chkPacksPlans && chkPacksNames && chkPacksInvalids)
      }
      return true
    }
  },

  watch: {
    currentPage() {
      this.getSpecialties()
    }
  },

  async created() {
    this.getSpecialties()
    this.getPlans()
  },

  methods: {
    async getPlans() {
      this.plans = await this.getAllPlans()      
    },

    async getSpecialties() {
      const response = await this.getSpecialtiesList({ page: this.currentPage - 1 })

      if (response) {
        this.specialties = response.content
        this.totalPages = response.totalPages
      }
    },

    async resetFlux() {
      await this.getSpecialties()
      this.isEditModal = false
      this.selected = null
    },

    updateAvailablePlans() {
      const selectedPlans = this.selected.packs.reduce((acc, pack) => acc.concat(pack.plans), [])
    
      this.selected.plans = this.plans.filter((plan) => !selectedPlans.find((p) => p.id === plan.id))

      this.selected.plans.forEach((plan) => { 
        if (!plan.name.includes(`(${plan.code})`)) {
          plan.name = `${plan.name} (${plan.code})`;
        } 
      })
    },

    openSpecialtyModal() {
      this.$bvModal.show('specialty-modal')
    },

    closeSpecialtyModal() {       
      this.$bvModal.hide('specialty-modal')
      
      setTimeout(() => {
        this.resetFlux()
      }, 300);
    },

    openPackGroupModal(name) {
      this.packRemovalName = name
      this.$bvModal.show('group-confirm-modal')
    },

    closePackGroupModal() {
      this.$bvModal.hide('group-confirm-modal')
    },

    addNewPack() {
      this.selected.packs.push({
        name: '',
        value: null,
        plans: [],
        invalidName: '',
        invalidValue: '',
      })
    },

    removePack() {
      this.closePackGroupModal()

      const tabIndex = this.selected.packs.findIndex((tab) => tab.name === this.packRemovalName)

      if (tabIndex >= 0) {
        this.selected.packs.splice(tabIndex, 1)

        this.updateAvailablePlans()
      }
    },

    validatePackField(selPack, sIndex, type) {
      clearTimeout(this.packTimeOut)

      const validations = {
        value: { fieldName: 'invalidValue', errorMessage: 'Valor' },
        name: { fieldName: 'invalidName', errorMessage: 'Nome'}
      }
      const { fieldName, errorMessage } = validations[type]

      this.packTimeOut = setTimeout(() => {
        this.selected.packs.forEach((pack) => pack[fieldName] = '')

        if (!selPack[type]) {
          selPack[fieldName] = 'Campo obrigatório'
        } else {
          const chkDuplicates = this.selected.packs.filter((pack, index) => pack[type] === selPack[type] && index !== sIndex)

          if (chkDuplicates.length) {
            selPack[fieldName] = `${errorMessage} duplicado`

            chkDuplicates.forEach((pack) => pack[fieldName] = `${errorMessage} duplicado`)
          }
        }
      }, 500)      
    },

    addPlanOnPack(val, sIndex) {
      this.selected.packs[sIndex].plans.push(val)

      this.updateAvailablePlans()
    },

    delPlanFromPack(id, sIndex) {
      const { plans } = this.selected.packs[sIndex]
      this.selected.packs[sIndex].plans = plans.filter((plan) => plan.id !== id)
      this.updateAvailablePlans()
    },

    configureSpecialty(id) {
      this.isEditModal = false

      this.selected = {
        specialty: id,
        plans: [ ...this.plans ],
        packs: []
      }

      this.addNewPack()

      this.openSpecialtyModal()
    },

    async editSpecialty(id) {
      await this.$vs.loading()

      this.isEditModal = true

      const response = await this.getSpecialtyById(id)

      if (response) {
        const packs = []
        response.plans.forEach(({ planName:name, planId: id, group, value, planCode: code}) => {
          const pack = packs.find((p) => p.name === group)
          if (pack) {
            pack.plans.push({ name, id, code })
          } else {
            packs.push({ value: value.toFixed(2), name: group, plans: [{ name, id, code}]})
          }
        })

        this.selected = {
          specialty: id,
          specialtyName: response.specialtyName,
          plans: [ ...this.plans ],
          packs: packs.map((pack) => ({
            ...pack, 
            invalidName: '',
            invalidValue: '',
          })),
          original: response.plans
        }

        await this.updateAvailablePlans()
        await this.openSpecialtyModal()
        await this.$vs.loading.close()
      }
    },

    async saveSpecialty() {
      await this.$vs.loading()

      const payload = {
        specialtyId: this.selected.specialty,
        plans: [],
        excluded: []
      }

      this.selected.packs.forEach((pack) => {
        pack.plans.forEach((plan) => (
          payload.plans.push({
            group: pack.name,
            planId: plan.id,
            value: parseFloat(pack.value.split(',').join('.'))
          }))
        )
      })

      if (this.isEditModal) {
        this.selected.original.forEach((checkPlan) => {
          if (!payload.plans.find((plan) => plan.planId === checkPlan.planId)) {
            payload.excluded.push(checkPlan.planId)
          }
        })
      }
      
      const response = this.isEditModal
        ? await this.updateSpecialty(payload)
        : await this.setSpecialty(payload)

      if (response.success) {
        await this.getSpecialties()
        await this.$vs.loading.close()
        
        this.$swal({
          title: "Sucesso!",
          text: "Dados registrados com sucesso.",
          icon: "success",
        })
          .then(async () => {
            await this.closeSpecialtyModal()
          })
      }
    },
  }
};
</script>

<style lang="scss" src="./SpecialtiesManagement.scss" scoped />
